/**
 * Hero status card for chapter home pages.
 */
import { introCardKeyline, introHeadlineSerif } from '../../designSystem';
import { resolveDotColor } from '../../data/chapterThemes';

const FONT = '"Plus Jakarta Sans", -apple-system, sans-serif';

export default function HeroStatusCard({ theme, eyebrow, headline, subline, pills, linkLabel, onLink }) {
  return (
    <div
      style={{
        background: `linear-gradient(140deg, ${theme.accentBg}, ${theme.gradientEnd || 'var(--sage-l)'})`,
        ...introCardKeyline,
        padding: '22px 26px',
        marginBottom: 16,
      }}
    >
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: theme.accentText, marginBottom: 6 }}>
        {eyebrow}
      </div>
      <div style={introHeadlineSerif}>{headline}</div>
      <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 14 }}>{subline}</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {(pills || []).map((p, i) => (
            <span
              key={i}
              style={{
                fontSize: 11,
                fontWeight: 600,
                padding: '4px 12px',
                borderRadius: 999,
                background: 'rgba(255,255,255,0.7)',
                color: theme.accentText,
                border: `0.5px solid ${theme.accent}40`,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              {p.dot && (
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    background: resolveDotColor(p.dotColor),
                    flexShrink: 0,
                  }}
                />
              )}
              {p.label}
            </span>
          ))}
        </div>
        {linkLabel && (
          <button
            type="button"
            onClick={onLink}
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: theme.accentText,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontFamily: FONT,
            }}
          >
            {linkLabel}
          </button>
        )}
      </div>
    </div>
  );
}
